import Page from "../../../layout/Page/Page";
import PageWrapper from "../../../layout/PageWrapper/PageWrapper";
import { CommonServiceList } from "./Common/CommonServiceList";

const ServicePage = () => {
	return (
		<PageWrapper title='Serviços'>
			<Page container='fluid'>
				<div className='row'>
					<div className='col-12'>
						<CommonServiceList />
					</div>
				</div>
			</Page>
		</PageWrapper>
	);
};

export default ServicePage;